import React from 'react'
import styled from '@emotion/styled'
import { array, object, string } from 'prop-types'
import QueryString from 'qs'

import { BackToTopSticky, PageWrapper, RenderBelowFold } from '@jelly/components'
import { AdvertisingDisclosure } from './AdvertisingDisclosure'
import { BuyingGuideSection } from './BuyingGuideSection'
import { Footer } from './Footer'
import { Header } from './Header'
import { JumpBar } from './JumpBar'
import { RfqWidgetSection } from './RfqWidgetSection'
import { ServicesSection } from './ServicesSection'

const BackToTopStickyStyled = styled(BackToTopSticky)`
	right: 20px;
`
TopFiveQT.propTypes = {
	backgroundImage: string.isRequired,
	meta: object.isRequired,
	sections: array.isRequired,
	services: array.isRequired,
	subtitle: string,
	rfqWidget: object.isRequired,
	title: string.isRequired,
}
/**
 * Top Five QT Landing page template
 *
 * @param {String} props.backgroundImage :: url of background image
 * @param {Object} props.meta :: meta data for the page
 * @param {Array} props.sections :: sections
 * @param {Array} props.services :: services
 * @param {String} props.subtitle :: subtitle
 * @param {String} props.title :: title
 */
export function TopFiveQT({ backgroundImage, meta, sections, services, subtitle, title, rfqWidget }) {
	const firstThreeServices = services.slice(0, 3)

	return (
		<PageWrapper meta={meta}>
			{/* TODO - is this needed?  */}
			{/* <JsonLd item={ArticleSchema({ author, canonical, content, lastModified, published, title, thumbnail })} /> */}
			<AdvertisingDisclosure />
			<Header backgroundImage={backgroundImage} subtitle={subtitle} title={title} />
			<ServicesSection services={services} />
			<JumpBar
				links={[
					{ text: 'View Offers', jumpLink: '#services' },
					{ text: 'Compare Price Quotes', jumpLink: '#widget' },
				]}
			/>
			<BuyingGuideSection sections={sections} services={firstThreeServices} />
			<RfqWidgetSection {...rfqWidget} />
			<RenderBelowFold>
				<BackToTopStickyStyled />
			</RenderBelowFold>
			<Footer />
		</PageWrapper>
	)
}

/**
 * grab marketingId url from current page query
 * @param {String} query query string that may contain marketingId
 * @param {String} url Monetization URL with tracking parameters
 */
export const generateMarketingIdUrl = (query, url) => {
	const { marketingId = '' } = QueryString.parse(query?.split('?')[1])
	const marketingIdUrl = url?.replace('[marketingId]', marketingId)

	return url ? marketingIdUrl : null
}
